import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Impressum = () => {
  return (
    <LegalLayout title="Impressum">
      <section>
        <h2 className="font-serif text-xl text-white font-bold mb-3">Angaben gemäß § 5 TMG</h2>
        <p className="text-gray-300">Marc Arndt</p>
        <p>c/o Schürpf Consulting</p>
        <p>Chli Ebnet 1</p>
        <p>CH-6403 Küssnacht am Rigi</p>
        <p>Schweiz</p>
      </section>

      <section>
        <h2 className="font-serif text-xl text-white font-bold mb-3">Kontakt</h2>
        <p>
          E-Mail:{' '}
          <a href="mailto:gcvllc@gmail.com" className="text-gold hover:underline">
            gcvllc@gmail.com
          </a>
        </p>
      </section>

      <section>
        <h2 className="font-serif text-xl text-white font-bold mb-3">Haftungsausschluss</h2>
        <div className="bg-gold/5 border border-gold/20 rounded-xl p-5">
          <p className="text-gray-300 font-semibold mb-2">⚠ Hinweis: Keine Anlageberatung</p>
          <p>
            Die Inhalte dieser Website und des Buches dienen ausschließlich zu
            Informationszwecken und stellen keine Anlageberatung, Finanzberatung oder
            Empfehlung zum Kauf oder Verkauf von Wertpapieren dar. Investitionen sind mit
            Risiken verbunden. Der Wert von Investments kann steigen und fallen. Vergangene
            Wertentwicklungen sind kein verlässlicher Indikator für zukünftige Ergebnisse.
          </p>
        </div>
      </section>

      <section>
        <h2 className="font-serif text-xl text-white font-bold mb-3">Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
          Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
          als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-xl text-white font-bold mb-3">Urheberrecht</h2>
        <p>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
          unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
          Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
          bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-xl text-white font-bold mb-3">Amazon Affiliate</h2>
        <p>
          Diese Website nimmt am Amazon-Partnerprogramm teil. Als Amazon-Partner verdiene ich
          an qualifizierten Verkäufen. Amazon und das Amazon-Logo sind Warenzeichen von
          Amazon.com, Inc. oder eines seiner verbundenen Unternehmen.
        </p>
      </section>
    </LegalLayout>
  );
};

export default Impressum;